module.exports = __webpack_public_path__ + "img/title_uk.23fa2daa.svg";